import createAction from '@clearscore-group/lib.helpers.create-action';
import createRequestPayload from '@clearscore-group/lib.helpers.create-request-payload';
import { NZ, AU } from '@clearscore-group/lib.config.i18n';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as requestStatuses from '@clearscore-group/lib.constants.request-statuses';
import { PROFILE_FETCH_SUCCESS } from '@clearscore-group/lib.constants.profile-action-types';
import { createSelector } from 'reselect';
import resolveRequest, { getRequestStatus } from '@clearscore-group/lib.helpers.resolve-request';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';
var marketConfig = function marketConfig(market) {
  switch (market) {
    case AU:
      return {
        url: '/au-registration/v1/prospect'
      };
    case NZ:
      return {
        url: '/nz-registration/v1/prospect'
      };
    default:
      {
        return {
          url: '/cs-registration/v1/prospect'
        };
      }
  }
};
var PROSPECT = 'CS/PROSPECT';
var PROSPECT_GET = "".concat(PROSPECT, "_GET");
var PROSPECT_GET_SUCCESS = "".concat(PROSPECT, "_GET_SUCCESS");
var PROSPECT_GET_ERROR = "".concat(PROSPECT, "_GET_ERROR");
var PROSPECT_REGISTER = "".concat(PROSPECT, "_REGISTER");
var PROSPECT_CREATE = "".concat(PROSPECT, "_CREATE");
var PROSPECT_CREATE_SUCCESS = "".concat(PROSPECT, "_CREATE_SUCCESS");
var PROSPECT_CREATE_ERROR = "".concat(PROSPECT, "_CREATE_ERROR");
var PROSPECT_CLEAR = "".concat(PROSPECT, "_CLEAR");
var typesImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PROSPECT_GET: PROSPECT_GET,
  PROSPECT_GET_SUCCESS: PROSPECT_GET_SUCCESS,
  PROSPECT_GET_ERROR: PROSPECT_GET_ERROR,
  PROSPECT_REGISTER: PROSPECT_REGISTER,
  PROSPECT_CREATE: PROSPECT_CREATE,
  PROSPECT_CREATE_SUCCESS: PROSPECT_CREATE_SUCCESS,
  PROSPECT_CREATE_ERROR: PROSPECT_CREATE_ERROR,
  PROSPECT_CLEAR: PROSPECT_CLEAR
});

// eslint-disable-next-line import/prefer-default-export
var createProspect = function createProspect(data, market, headers) {
  var _marketConfig = marketConfig(market),
    url = _marketConfig.url;
  return createAction(PROSPECT_CREATE, createRequestPayload('international', url, 'post', data, {
    market: market
  }, headers));
};
var getProspect = function getProspect(prospectId, market, headers) {
  var _marketConfig2 = marketConfig(market),
    url = _marketConfig2.url;
  return createAction(PROSPECT_GET, createRequestPayload('international', "".concat(url, "/").concat(prospectId), 'get', null, {
    market: market
  }, headers));
};
var register = function register(data) {
  return createAction(PROSPECT_REGISTER, data);
};
var clearProspect = function clearProspect() {
  return createAction(PROSPECT_CLEAR);
};
var actionsImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createProspect: createProspect,
  getProspect: getProspect,
  register: register,
  clearProspect: clearProspect
});
var initialState = {
  status: requestStatuses.INITIAL
};
var domain$1 = function domain$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case PROSPECT_REGISTER:
      return _objectSpread(_objectSpread({}, state), payload);
    case PROSPECT_GET:
    case PROSPECT_CREATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: requestStatuses.PENDING
      });
    case PROSPECT_GET_SUCCESS:
    case PROSPECT_CREATE_SUCCESS:
      return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
        status: requestStatuses.SUCCESS
      });
    case PROSPECT_GET_ERROR:
    case PROSPECT_CREATE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: requestStatuses.ERROR
      });
    case PROSPECT_CLEAR:
    case PROFILE_FETCH_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

/* eslint-disable import/prefer-default-export */
var domain = domain$1;
var reducersImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  domain: domain
});
var getProspectStatus = function getProspectStatus(state) {
  return resolveRequest(state, 'prospect.status');
};
var prospectGetPredicate = createSelector(getProspectStatus, function (status) {
  return {
    fetch: getRequestStatus(status)
  };
});
var getProspectId = function getProspectId(state) {
  return resolveProp('prospect.prospectId', state);
};
var getEmail = function getEmail(state) {
  return resolveProp('prospect.email', state);
};
var getMarket = function getMarket(state) {
  return resolveProp('prospect.market', state) || resolveProp('prospect.region', state);
};
var getValidEmail = function getValidEmail(state) {
  return resolveProp('prospect.validEmail', state);
};
var getProspectHasAccount = function getProspectHasAccount(state) {
  return resolveProp('prospect.prospectHasAccount', state);
};
var getAllowedUser = function getAllowedUser(state) {
  return resolveProp('prospect.allowedUser', state);
};
var prospectGetSimple = createSelector(getProspectId, getEmail, getMarket, getValidEmail, getProspectHasAccount, getAllowedUser, function (prospectId, email, market, validEmail, prospectHasAccount, allowedUser) {
  return {
    prospectId: prospectId,
    email: email,
    market: market,
    validEmail: validEmail,
    prospectHasAccount: prospectHasAccount,
    allowedUser: allowedUser
  };
});
var getPredicate = prospectGetPredicate;
var getSimple = prospectGetSimple;
var selectorsImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getPredicate: getPredicate,
  getSimple: getSimple
});
var actions = actionsImport;
var reducers = reducersImport;
var selectors = selectorsImport;
var types = typesImport;
export { actions, reducers, selectors, types };